"use client";
import {
  Flex,
  Grid,
  Image,
  Stack,
  Button,
  GridItem,
  useDisclosure,
  IconButton,
} from "@chakra-ui/react";
import { PromptModal } from "components"; // ✅ Import PromptModal
import { useGetAdminModelImages, useToggleGalleryApproval } from "queries";
import { useState, useEffect, useRef } from "react";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";


export const AdminImageGenerations = ({ id }: { id: string }) => {
  const [page, setPage] = useState<number>(1);
  const [selectedImage, setSelectedImage] = useState<any | null>(null); // ✅ Store selected image object
  const { isOpen, onOpen, onClose } = useDisclosure();
  const pageSize = 16;
  const { data, refetch } = useGetAdminModelImages({ page, pageSize, id });
  const [localApprovals, setLocalApprovals] = useState<Record<string, boolean>>({});

  const nextPage = () => setPage((prevPage) => prevPage + 1);
  const prevPage = () => setPage((prevPage) => Math.max(1, prevPage - 1));
  const totalPages = Math.ceil(data?.total_image_generations / pageSize);
  const toggleApproval = useToggleGalleryApproval();
  const hasInitializedApprovals = useRef(false); // 👈 create a ref

  // ✅ Handle image click: Open PromptModal instead of simple modal
    // ✅ Fix: Ensure correct image URL is used
    const handleImageClick = (image: any) => {
      const imageUrl = image.file_name?.startsWith("https")
        ? image.file_name
        : image.sas_url;
  
      setSelectedImage({
        ...image,
        displayUrl: imageUrl, // ✅ Store final image URL
      });
      onOpen();
    };

    const handleApprovalToggle = (e: React.MouseEvent, imageId: string, currentApproved: boolean) => {
      e.stopPropagation();
    
      // Optimistic update: flip based on actual value
      setLocalApprovals((prev) => ({
        ...prev,
        [imageId]: !((imageId in prev ? prev[imageId] : currentApproved)),
      }));
    
      toggleApproval.mutate(imageId, {
        onError: () => {
          // Revert on error
          setLocalApprovals((prev) => ({
            ...prev,
            [imageId]: (imageId in prev ? prev[imageId] : currentApproved), // revert to previous
          }));
        },
      });
    };
    
  


  return (
    <Flex px={["25px", "35px", "40px", "60px", "60px", "18%"]} align="center" direction="column">
      <Stack mt="40px" spacing={4} direction="row" align="center" justify="center" mb={4}>
        <Button onClick={prevPage} disabled={page === 1}>
          Previous
        </Button>
        <Button onClick={nextPage} isDisabled={page >= totalPages}>
          Next
        </Button>
      </Stack>

      {/* ✅ Display Images */}
      <Grid  mt="25px"
          gap={2}
          templateColumns={{
            base: "repeat(2,1fr)",
            md: "repeat(3,1fr)",
            lg: "repeat(4,1fr)",
          }}>
        {data?.image_generations?.map((image: any) => {
          console.log("image object", image); // ✅ Add this line here

          const imageId = image.id;
          const isApproved =
          imageId in localApprovals
            ? localApprovals[imageId]
            : image.approved_for_gallery;

  return (
    <GridItem position="relative" key={image.id}>
      <Image
        boxShadow="0 0 5px 5px rgb(44, 49, 77)"
        borderRadius="14px"
        maxW="100%"
        src={
          image.file_name.startsWith("http")
            ? image.file_name
            : image.sas_url
        }
        objectFit="cover"
        onClick={() => handleImageClick(image)}
        cursor="pointer"
      />

      {/* Approval Toggle Button */}
      <IconButton
        aria-label="Toggle Approval"
        icon={
          isApproved ? (
            <AiFillHeart color="hotpink" />
          ) : (
            <AiOutlineHeart color="white" />
          )
        }
        position="absolute"
        top="8px"
        right="8px"
        size="sm"
        variant="ghost"
        bg="rgba(0,0,0,0.5)"
        _hover={{ bg: "rgba(255,255,255,0.1)" }}
        onClick={(e) => {
          handleApprovalToggle(e, image.id, image.approved_for_gallery);
        }}
      />
    </GridItem>
  );
})}

      </Grid>

      {/* ✅ Use `PromptModal` Instead of `Modal` */}
      {selectedImage && (
        <PromptModal 
          isOpen={isOpen} 
          onClose={onClose} 
          isFlux={true} 
          model_id={id} 
          generationImage={selectedImage.displayUrl || ""}
          file_name={selectedImage.file_name || ""}
        />
      )}
    </Flex>
  );
};

export default AdminImageGenerations;
